// Global Instructions Rule Applied!

import React from 'react'
import { InvestmentsForm } from './components/InvestmentsForm.tsx'

export default function InvestmentsPage(): React.ReactElement {
  return <InvestmentsForm />
}
